/**
 * Prefer offline start snapshot (has real plant/department) over persisted employeeDetails
 * (which can still be "N/A" when offline or before Plant Tour sync).
 */
export function mergePlanTourEmployee(
  employeeDetails: any | null | undefined,
  offlineEmployeeDetails: any | null | undefined
): any | null {
  if (offlineEmployeeDetails && typeof offlineEmployeeDetails === 'object') {
    return { ...(employeeDetails && typeof employeeDetails === 'object' ? employeeDetails : {}), ...offlineEmployeeDetails };
  }
  return employeeDetails ?? null;
}
